import React, { useEffect, useState } from 'react';

import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { Grid, Box, Typography, Card, Button, Zoom } from '@mui/material';
import { Stack, useMediaQuery } from '@mui/material';

import DashboardNavbar from '../../Components/DashboardNavbar/DashboardNavbar';
import CreateClassModal from '../../Components/Modals/CreateClassModal';
import CookieLoad from '../../util/CookieLoad';

function ClassSelect(props) {
    const [classes, setClasses] = useState([]);
    const [tokens, setTokens] = useState({});
    const navigate = useNavigate();

    const sm = useMediaQuery('(min-width:600px)');
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const addClass = (classData) => {
        setClasses([classData, ...classes]);
    }

    const fetchClasses = async (tokens) => {
        axios.get(`${process.env.REACT_APP_API_HOST}/api/class/getTaughtClasses`, 
        {
            headers: {Authorization: `Bearer ${tokens.access_token}`}
        })
        .then(res => res.data)
        .then(data => setClasses(data))
        .catch(error => console.error(error));
    };

    useEffect(() => {
        const getTokens = async () => {
            const tokens = await CookieLoad();
            if (!tokens) {
                navigate("/");
                console.log("Cannot login user");
            }
            setTokens(tokens);
            fetchClasses(tokens);    
        } 
        getTokens();
    }, [])

    return (
        <Box>
            <DashboardNavbar userType="admin"/>
            <Box sx={{ px: 3, my: 3, marginInline: "auto", maxWidth: 1400}}>
                <Typography variant="h4">Class Selection</Typography>
                <Box mb={2} sx={{display: "flex", justifyContent: "flex-end"}}>
                    <Button variant="contained" onClick={handleOpen} style={{minWidth: (sm ? 143 : 100), backgroundColor: '#2E2E2E'}} >{sm ? "Create Class" : "Create"}</Button>
                    <CreateClassModal open={open} closeModal={handleClose} addClass={addClass} tokens={tokens}></CreateClassModal>
                </Box>
                <Grid container spacing={4}>
                    {classes.length > 0 ? classes.map((item, index) => (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={item.class_id}>
                            <Zoom in={true} timeout={(index < 8) ? 450 : 100} style={{transitionDelay: (150 * (index - index / 5))}}>
                                {/* Cant easily put card into a seperate components as there are problems with functional components and mui transitions */}
                                <Card style={{ padding: 10, paddingLeft: 15, height: 142, background: "#ECF7FF" }}>
                                    <Stack style={{justifyContent:"space-between", height: "100%"}}>
                                        <Box>
                                            <Typography variant="h6">{item.name}</Typography>
                                            <Typography variant="body1">{item.sd1_term + " " + item.sd1_year}</Typography>
                                            <Typography variant="body1">{item.students && "Students: " + item.students}</Typography>
                                        </Box>
                                        <Box sx={{ display: "flex", justifyContent: 'flex-end', alignSelf: "flex-end" }}>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                onClick={() => navigate(`/classview`, {
                                                    state: {
                                                        token: tokens,
                                                        class_id: item.class_id,
                                                        department: item.department,
                                                        name: item.name,
                                                        startSemester: item.sd1_term,
                                                        year: item.sd1_year,
                                                        coordinators: item.users
                                                    }
                                                })}
                                            >
                                                View
                                            </Button>
                                        </Box>
                                    </Stack>
                                </Card>
                            </Zoom>
                        </Grid>
                    )) : <Grid item xs={12}>
                            <Typography variant="h6" align="center">No Classes</Typography>
                        </Grid>
                    }
                </Grid>
            </Box>
        </Box>
    );
}

export default ClassSelect;